import { useCompany } from 'store/server/useCompany'
import SearchSelect from '../search-select'
import { useFormikContext } from 'formik'
import { useEffect, useMemo } from 'react'
import { useAuth } from 'store/client/authStore'

const SUPER_COMPANY_ID = '6562742a5b252fdddcc5890d'

export function SelectCompany({ name, labelName, changename }) {
  const { values, setFieldValue } = useFormikContext()
  const { data, isFetched, isSuccess } = useCompany()
  const { user } = useAuth()

  // Güvenli yardımcılar
  const normalizeId = (x) => (x == null ? '' : String(x))
  const userCompanyId = normalizeId(user?.companyId)

  // options'u güvenli ve kararlı oluştur
  const options = useMemo(() => {
    const list = Array.isArray(data) ? data : []
    // id veya _id; hepsini string'e çevir
    const mapped = list.map(({ name: n, id, _id }) => ({
      value: normalizeId(id ?? _id),
      label: n ?? ''
    }))

    if (userCompanyId && userCompanyId !== SUPER_COMPANY_ID) {
      return mapped.filter((o) => o.value === userCompanyId)
    }
    return mapped
  }, [data, userCompanyId])

  // values[name] veya user.companyId'ye göre seçimi tut
  useEffect(() => {
    if (!isSuccess || options.length === 0) return

    const currentValue = normalizeId(values?.[name])
    let next = options.find((o) => o.value === currentValue)

    // Formik boşsa user şirketi
    if (!next && userCompanyId && userCompanyId !== SUPER_COMPANY_ID) {
      next = options.find((o) => o.value === userCompanyId)
    }

    // Hâlâ yoksa tek seçenekse onu seç
    if (!next && options.length === 1) {
      next = options[0]
    }

    if (next && currentValue !== next.value) {
      setFieldValue(name, next.value)
    }
  }, [isSuccess, options, values?.[name], userCompanyId, name, setFieldValue])

  return (
    <SearchSelect
      label={changename}
      name={name}
      labelName={labelName}
      options={options}
      // Değer Formik'ten gelsin ki form-state ile senkron kalsın
      value={options.find((o) => o.value === normalizeId(values?.[name])) ?? null}
      onChange={(opt) => {
        setFieldValue(name, opt ? opt.value : '')
      }}
      // isLoading={!isSuccess} // istersen aç
    />
  )
}
